<template>
  <div class="image-text-black">
    <div class="row">
      <div class="col big">
        <div class="image">
          <div
            class="bg"
            v-if="content.image_one"
            :style="`background-image: url(${content.image_one.sizes.large})`"
            :data-pin-url="url"
            :data-pin-media="content.image_one.url"
            :data-pin-description="content.image_one.description"
            v-on:click="imageClick(content.image_one.sizes.large, content.image_one.caption)"
          ></div>
          <div
            class="post-image-caption"
            v-if="content.image_one && content.image_one.caption"
            v-html="content.image_one.caption"
          ></div>
        </div>
      </div>
      <div class="col">
        <div class="text" v-html="content.text_one"></div>
      </div>
    </div>
    <div class="row">
      <div class="col big">
        <div class="text" v-html="content.text_two"></div>
      </div>
      <div class="col">
        <div class="image">
          <div
            class="bg"
            v-if="content.image_two"
            :style="`background-image: url(${content.image_two.sizes.large})`"
            :data-pin-url="url"
            :data-pin-media="content.image_two.url"
            :data-pin-description="content.image_two.description"
            v-on:click="imageClick(content.image_two.sizes.large, content.image_two.caption)"
          ></div>
          <div
            class="post-image-caption"
            v-if="content.image_two && content.image_two.caption"
            v-html="content.image_two.caption"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "image_text_black",
  props: {
    content: Object,
    imageClick: Function,   
    url: {
      type: String,
      default: ''
    },
  }
};
</script>

<style lang="scss">
.image-text-black {
  background: $black;
  color: $white;
  padding-top: 100px;
  .row {
    display: flex;
    align-items: center;
    .col {
      flex: 0.4;
      &.big {
        flex: 0.6;
      }
      .image {
        position: relative;
        width: 100%;
        height: 540px;
        background: rgba(255, 255, 255, 0.1);
        z-index: 1;
        .bg {
          width: 100%;
          height: 100%;
          background-position: center center;
          background-size: cover;
          cursor: pointer;
        }
      }
      .text {
        padding: 50px;
        strong {
          color: $white !important;
        }
      }
    }
  }
}
@media (max-width: $tablet) {
  .image-text-black {
    padding: 50px 0;
    .row {
      .col {
        flex: 0.5;
        &.big {
          flex: 0.5;
        }
        .image {
          width: calc(100% - 50px);
          margin-right: 50px;
          height: 440px;
        }
      }
    }
  }
}
@media (max-width: $mobile) {
  .image-text-black {
    padding: 50px 0 25px 0;
    .row {
      flex-direction: column;
      max-width: 90%;
      margin: 0 auto;
      .col {
        width: 100%;
        flex: 1;
        &.big {
          flex: 1;
        }
        .image {
          width: 100%;
          margin-right: 0;
          height: 320px;
          margin-bottom: 25px;
        }
        .text {
          position: relative;
          padding: 0;
          margin-bottom: 25px;
          z-index: 1;
        }
      }
    }
  }
}
@media (max-width: $small-mobile) {
  .image-text-black {
    .row {
      .col {
        .image {
          height: 240px;
        }
      }
    }
  }
}
</style>